import { useState } from 'react';
import {
  Alert,
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import i18n from '@/utils/i18n';
import { PageHeaderButton } from '../../components/Layout';
import { useCreateStoreMutation } from '../../graphql/mutations/createStore.generated';
import { Currency } from '../../graphql/generatedTypes';
import { Routes } from '@/utils/routes';

const CURRENCY_OPTIONS: { label: string; value: Currency }[] = [
  { label: 'EU', value: Currency.Eur },
  { label: 'GB', value: Currency.Gbp },
  { label: 'NO', value: Currency.Nok },
  { label: 'IL', value: Currency.Ils },
  { label: 'CH', value: Currency.Chf },
  { label: 'MX', value: Currency.Mxn },
  { label: 'SE', value: Currency.Sek },
  { label: 'HU', value: Currency.Huf },
  { label: 'US', value: Currency.Usd },
  { label: 'DK', value: Currency.Dkk },
  { label: 'DO', value: Currency.Dop },
  { label: 'PL', value: Currency.Pln },
  { label: 'AL', value: Currency.All },
  { label: 'ZA', value: Currency.Zar },
  { label: 'AE', value: Currency.Aed },
];

export default function AddStoreOrphanButton() {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [currency, setCurrency] = useState<Currency>(Currency.Eur);
  const [error, setError] = useState('');

  const [createStore, { loading }] = useCreateStoreMutation();

  const handleCreate = async () => {
    setError('');
    try {
      const result = await createStore({
        variables: {
          payload: {
            brand_id: null,
            name,
            currency,
            address: {},
            latitude: '0',
            longitude: '0',
          },
        },
      });
      const newStoreId = result.data?.createStore?.id;
      if (!newStoreId) {
        setError(i18n.t('Common:error'));
        return;
      }
      setIsModalOpen(false);
      history.push(Routes.partnerStore(newStoreId));
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  };

  return (
    <>
      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(!isModalOpen)}>
        <ModalHeader>{i18n.t('Merchants:addStore')}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label style={{ margin: '0.5em' }}>
              {i18n.t('Merchants:storeName')}
            </Label>
            <Input
              style={{ marginBottom: '0.5em' }}
              type="text"
              placeholder={i18n.t('Merchants:store1')}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Label style={{ margin: '0.5em' }}>
              {i18n.t('Merchants:storeCreationNote')}
            </Label>
            <select
              className="form-control"
              value={currency}
              onChange={(e) => setCurrency(e.target.value as Currency)}
            >
              {CURRENCY_OPTIONS.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </select>
          </FormGroup>
          {error ? <Alert color="danger">{error}</Alert> : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            className="text-white"
            onClick={handleCreate}
            disabled={!name || loading}
          >
            {loading ? i18n.t('Common:loading') : i18n.t('Merchants:addStore')}
          </Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            {i18n.t('Common:close')}
          </Button>
        </ModalFooter>
      </Modal>
      <PageHeaderButton
        icon={<FaPlus />}
        label={i18n.t('Merchants:addStore')}
        onClick={() => setIsModalOpen(true)}
      />
    </>
  );
}
